/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Distributors {
    angular.module("meevo.plugins.distributors", []);
}